import Vue from 'vue';
import Router from 'vue-router';
import PageHome from '@/pages/Home';
import PageMonitoring from '@/pages/Monitoring';
import PageResults from '@/pages/Results';
import PageResultsSuperbet from '@/pages/Results.Superbet';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'PageHome',
      component: PageHome,
    },
    {
      path: '/monitoring',
      name: 'PageMonitoring',
      component: PageMonitoring,
    },
    {
      path: '/results',
      name: 'PageResults',
      component: PageResults,
    },
    {
      path: '/results/superbet',
      name: 'PageResultsSuperbet',
      component: PageResultsSuperbet,
      meta: {
        config: 'superbet',
      },
    },
    {
      path: '/results/superbet-web',
      name: 'PageResultsSuperbet',
      component: PageResultsSuperbet,
      meta: {
        config: 'superbetWeb',
      },
    },
  ],
});
